import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@iconify/react';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';

import { useNavigate } from 'react-router';

// material

import { Typography, Box, Rating, Pagination } from '@mui/material';
import {
  DataGrid,
  useGridSlotComponentProps,
  getGridNumericColumnOperators,
  GridToolbarContainer,
  GridToolbarExport
} from '@mui/x-data-grid';
// utils
import { useSelector, useDispatch } from 'react-redux';

// components
import { MIconButton } from '../../../../components/@material-extend';
import { fetchSalaries } from '../../../../redux/slices/salary';
// ----------------------------------------------------------------------

const columns = [
  // OPTIONS
  // https://material-ui.com/api/data-grid/grid-col-def/#main-content
  // - hide: false (default)
  // - editable: false (default)
  // - filterable: true (default)
  // - sortable: true (default)
  // - disableColumnMenu: false (default)

  // FIELD TYPES
  // --------------------
  // 'string' (default)
  // 'number'
  // 'date'
  // 'dateTime'
  // 'boolean'
  // 'singleSelect'

  {
    field: 'programStudiedId',
    hide: true
  },

  {
    field: 'programName',
    headerName: 'Program',
    flex: 1
  },
  {
    field: 'averageSalary',
    headerName: 'Average salary',
    flex: 1
  },
  {
    field: 'startingSalary',
    headerName: 'Start salary',
    flex: 1,
    renderCell: (params) => {
      const getStartingSalary = params.getValue(params.id, 'startSalaryRange');
      return (
        <Typography variant="body2" noWrap>
          {getStartingSalary?.min} - {getStartingSalary?.max}
        </Typography>
      );
    }
  },
  {
    field: 'baseSalary',
    headerName: 'Base salary',
    flex: 1,
    renderCell: (params) => {
      const getBaseSalary = params.getValue(params.id, 'currentSalaryRange');
      return (
        <Typography variant="body2" noWrap>
          {getBaseSalary?.min} - {getBaseSalary?.max}
        </Typography>
      );
    }
  },
  {
    field: 'totalSalaries',
    headerName: 'Total submitted',
    flex: 1
  },

  {
    field: 'action',
    headerName: ' ',
    width: 80,
    align: 'right',
    sortable: false,
    filterable: false,
    disableColumnMenu: false,
    renderCell: (params) => {
      const selectedID = params.row.id;

      const handleClick = () => {
        console.log('selectedID', selectedID);
      };

      return (
        <MIconButton onClick={handleClick}>
          <Box component={Icon} icon={moreVerticalFill} sx={{ width: 20, height: 20 }} />
        </MIconButton>
      );
    }
  }
];

// ----------------------------------------------------------------------

function CustomPagination() {
  const { state, apiRef } = useGridSlotComponentProps();

  return (
    <Pagination
      color="primary"
      count={state.pagination.pageCount}
      page={state.pagination.page + 1}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}

RatingInputValue.propTypes = {
  applyValue: PropTypes.func.isRequired,
  item: PropTypes.shape({
    columnField: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operatorValue: PropTypes.string,
    value: PropTypes.any
  }).isRequired
};

function RatingInputValue({ item, applyValue }) {
  return (
    <Box sx={{ p: 1, height: 1, alignItems: 'flex-end', display: 'flex' }}>
      <Rating
        size="small"
        precision={0.5}
        placeholder="Filter value"
        value={Number(item.value)}
        onChange={(event, newValue) => {
          applyValue({ ...item, value: newValue });
        }}
      />
    </Box>
  );
}

export default function SalariesTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { salaries = [], loading } = useSelector((state) => state.salary);
  if (columns.length > 0) {
    const ratingColumn = columns.find((column) => column.field === 'rating');
    const ratingColIndex = columns.findIndex((col) => col.field === 'rating');

    const ratingFilterOperators = getGridNumericColumnOperators().map((operator) => ({
      ...operator,
      InputComponent: RatingInputValue
    }));

    columns[ratingColIndex] = {
      ...ratingColumn,
      filterOperators: ratingFilterOperators
    };
  }

  useEffect(() => {
    dispatch(fetchSalaries());
  }, [dispatch]);

  return (
    <DataGrid
      // checkboxSelection
      loading={loading}
      disableSelectionOnClick
      onCellClick={(params, event) => {
        navigate(`/dashboard/salaries/${params.id}`);
      }}
      rows={salaries}
      columns={columns}
      pagination
      pageSize={10}
      components={{
        Toolbar: CustomToolbar,
        Pagination: CustomPagination
      }}
    />
  );
}

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}
